export const USER_PROMPT_NONE = 'NONE'
export const ON_PAGE_TOP = 'PAGE_TOP'
export const ON_PAGE_BOTTOM = 'PAGE_BOTTOM'
export const USER_PROMPT_MODAL_INFO = 'MODAL_INFORMATIVE'
export const USER_PROMPT_MODAL_ACTION = 'MODAL_ACTIONABLE'
export const USER_PROMPT_MODAL_REMINDER = 'MODAL_REMINDER'
export const USER_PROMPT_MODAL_UPDATE = 'MODAL_ACTIONABLE_UPDATE'
